const info = {
  ZH: { //中文翻译
    msgOne: '\u6240\u9009\u7269\u8D28\u5206\u7C7B\u5141\u8BB8\u901A\u8FC7\u4E0B\u62C9\u5F0F\u83DC\u5355\u5E76\u6309\u7167CAMDS\u7684\u57FA\u672C\u805A\u5408\u7269\u6E05\u5355\u521B\u5EFA\u7269\u8D28\u540D\u79F0\u548C\u76F8\u5E94\u7B26\u53F7. \u8BF7\u9009\u62E9\u9002\u5408\u6B64\u7269\u8D28\u7684\u7B26\u53F7/\u7F29\u7565\u8BED.',
    title: '\u521B\u5EFA\u4E00\u4E2A\u65B0\u6750\u6599',
    title1: '\u72B6\u6001',
    title2: '\u6750\u6599\u7B26\u53F7\u7684\u7EC4\u5408',
    msgTwo: '\u60A8\u4E5F\u53EF\u4EE5\u5355\u72EC\u4FEE\u6539\u6B64\u7B26\u53F7\u6807\u8BB0 (\u6700\u4E0B\u9762\u7684\u6587\u672C\u8F93\u5165\u5B57\u6BB5). \u6B64\u9879\u5BF9\u4E8E\u5E26\u6709\u591A\u4E2A\u586B\u5145\u5242\u7684\u7269\u8D28(\u4F8B\u5982 \u73BB\u7483\u7EA4\u7EF4 GF \u548C \u77FF\u7269\u7C89 MD)\u662F\u5FC5\u8981\u7684. \u4F8B\u5982\: PA6-(GF15+MD10); \u6B64\u5904\u60A8\u53EF\u4EE5\u5355\u72EC\u6DFB\u52A0 "(...+MD10)" .',
    msgTh: '\u60A8\u4E5F\u53EF\u4EE5\u5355\u72EC\u4FEE\u6539\u6B64\u7B26\u53F7\u6807\u8BB0 (\u6700\u4E0B\u9762\u7684\u6587\u672C\u8F93\u5165\u5B57\u6BB5). ',
    cancel: '\u53D6\u6D88',
    next: '\u4E0B\u4E00\u6B65',
    mdsMaterial: '\u6750\u6599\u7B26\u53F7\u7684\u7EC4\u5408',
    newMaterial: '\u65B0\u5EFA\u4E00\u4E2A\u6750\u6599',
    newMaterialTitle: '\u521B\u5EFA\u4E00\u4E2A\u65B0\u6750\u6599',
    modifyMaterialTitle: '材料标识',
    Symbols: '\u7B26\u53F7\u7EC4\u5408\:',
    classified: '\u6750\u6599\u5206\u7C7B\:',
    material51a: '\u586B\u5145\u70ED\u5851\u6027\u5851\u6599',
    material51b: '\u672A\u586B\u5145\u70ED\u5851\u6027\u5851\u6599',
    material52: '\u70ED\u5851\u6027\u5F39\u6027\u4F53',
    material53: '\u6A61\u80F6',
    isoStandard10431: '\u57FA\u7840\u805A\u5408\u7269 ISO 1043-1\u6216GB/T 1844.1\:',
    isoStandard10432: '\u586B\u5145\u5242/\u52A0\u5F3A\u6750\u6599 ISO 1043-2\u6216GB/T 1844.2\:',
    isoStandard10433: '\u589E\u5851\u5242 ISO 1043-3\u6216GB/T 1844.3(\u53EF\u9009\u9879)\:',
    isoStandard10434: '\u963B\u71C3\u5242 ISO 1043-4\u6216GB/T 1844.4 (\u53EF\u9009\u9879)\:',
    isoStandard18064: '\u70ED\u5851\u6027\u5F39\u6027\u4F53 ISO 18064\u6216GB/T 22027\:',
    isoStandard1629: '\u57FA\u7840\u5F39\u6027\u4F53 ISO 1629\u6216GB/T 5576\:',
    material54: '\u70ED\u56FA\u6027\u5851\u6599',
    material541: '\u805A\u6C28\u916F',
    material542: '\u4E0D\u9971\u548C\u805A\u916F',
    material543: '\u5176\u5B83\u70ED\u56FA\u6027\u5851\u6599',
    material551: '\u5851\u6599\uFF08\u805A\u5408\u7269\u6DF7\u5408\u7269\uFF09',
    submit: '\u786E\u5B9A',
  },
  EN: { //英文翻译
    msgOne: '	The selected material classification permits creation of Name and Symbol field entries using dropdown selections derived from the CAMDS Basic Polymer List. Therefore please select the symbols/abbreviated terms suitable for the material',
    msgTwo: 'It is also possible to adapt the symbol manually (lowermost input field). This is necessary for materials with more than one filler (e. g. glassfibre GF and mineral powder MD).Example\: PA6-(GF15+MD10); here you can add ""(...+MD10)"" manually. ',
    msgTh: '	It is also possible to adapt the symbol manually (lowermost input field).',
    cancel: '	Cancel',
    next: '	Next',
    mdsMaterial: '	Composition of the material symbol',
    newMaterial: '	Create a material',
    newMaterialTitle: '	Create a new material',
    modifyMaterialTitle: 'Material symbol',
    Symbols: '	 Composed symbol:',
    classified: '	Material classification:',
    material51a: 'Filled Thermoplastics',
    material51b: 'Unfilled Thermoplastics',
    material52: '	Thermoplastic elastomers',
    material53: 'Elastomers',
    material54: 'Duromers',
    isoStandard10431: 'Basic polymers ISO 1043-1 or GB/T 1844.1\:',
    isoStandard10432: 'Fillers/reinforcing materials ISO 1043-2 or GB/T 1844.2\:',
    isoStandard10433: 'Plasticizers ISO 1043-3 or GB/T 1844.3 (optional)\:',
    isoStandard10434: 'Flame retardants ISO 1043-4 or GB/T 1844.4 (optional)\:',
    isoStandard18064: 'Thermoplastic elastomers ISO 18064 or GB/T 22027\: ',
    isoStandard1629: 'Basic elastomers ISO 1629 or GB/T 5576\: ',
    title: 'Creation of a new material',
    title1: 'State',
    title2: 'Composition of the material symbol',
    submit: 'ok',
    material541: 'Polyurethane',
    material542: 'Unsaturated polyester',
    material543: 'Other duromers',
    material551: 'Plastics (in polymeric compounds)',
  }
}
export default info //需要暴露出去
